import { Card, Grid, Text, Title } from '@mantine/core';

const AgentCards = ({ option, index, select }) => {
  return (
    <Grid.Col span={{ base: 12, md: 4 }} mb="lg">
      <Card
        bg={option.selected ? 'primary' : ''}
        c={option.selected ? 'white' : ''}
        onClick={() => select({ ...option, index })}
        padding="md"
        style={{ cursor: 'pointer' }}
      >
        <Title order={2}>
          {option.tablerIcon || null} {option.title}
        </Title>
        <Text c="gray.5" mb={0}>
          {option.description}
        </Text>
      </Card>
    </Grid.Col>
  );
};

export default AgentCards;
